export function getChartImageVersion(stock = {}) {
  const explicitVersion = stock.chart_generated_at || stock.chart_file_sha256 || stock.chart_run_id || stock.last_updated;
  if (explicitVersion) return String(explicitVersion);

  const longName = String(stock.long_fname || '').trim();
  const match = longName.match(/(\d{4}-\d{2}-\d{2}-\d{2}-\d{2})/);
  if (match) return match[1];

  return '';
}

export function appendVersion(url, version) {
  if (!url || !version) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(version)}`;
}

export function appendCacheKey(url, cacheKey) {
  if (!url || !cacheKey) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cache=${encodeURIComponent(cacheKey)}`;
}

export function buildChartImageUrl(
  stock = {},
  baseUrl = 'https://www.swingtradertrends.com/rj/img/',
  cacheKey = ''
) {
  const shortName = String(stock.short_fname || '').trim();
  if (!shortName) return null;

  const version = getChartImageVersion(stock);
  if (shortName.startsWith('http') || shortName.startsWith('data:')) {
    return appendCacheKey(appendVersion(shortName, version), cacheKey);
  }

  const url = `${baseUrl.replace(/\/?$/, '/')}${shortName.replace(/^\//, '')}`;
  return appendCacheKey(appendVersion(url, version), cacheKey);
}
